import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const AboutNew: React.FC<{ hlanguage: any,allImagesLink:any }> = ({ hlanguage,allImagesLink }) => {
  // const hlanguage = useSelector((state: any) => state.auth.homeLanguage);
const navigate = useNavigate();
const base_Url = process.env.REACT_APP_BASE_URL;

  return (
    <>
      <style>
       {`
       /* ===== Outer container (same as Bootstrap AboutUs) ===== */
.about-container{
  width:100%;
  background:#FAECC0;
  display:flex;
  justify-content:center;
}

.about-inner{
  width:100%;
  max-width:90vw;
}

.about-card{
  border-radius:1rem;
  overflow:hidden;
  padding:1.5rem; /* p-4 */
}

@media (min-width:768px){
  .about-card{
    padding:3rem; /* p-md-5 */
  }
}

/* ===== Layout ===== */
#main-about{
  width:100%;
}

.about-left{
  display:flex;
  gap:1.5rem;
  flex:0 0 50%;
  align-items:stretch;      /* CRITICAL: prevent stretch bug */
}

@media (min-width:992px){
  .about-left{
    gap:1.7rem;
  }
}

.tractor-wrap{
  flex:1;
}

.tractor-wrap img{
  width:100%;
  height:100%;
  min-height:420px;
  object-fit:cover;
  border-radius:1rem;
}

/* Right stacked column */
.stack-wrap{
  flex:1;
  display:flex;
  flex-direction:column;
  gap:1.5rem;
  height:100%;             /* lock height with tractor */
}

/* Since box */
.since-box{
  background:#15803d;
  border-radius:1rem;
  padding:1.2rem;
  color:white;
  width:100%;
  align-self:flex-start;
  flex:0 0 auto;           /* do NOT stretch */
}

.since-box span{
  font-size:clamp(0.7rem, 1.8vw, 0.85rem);
  letter-spacing:0.08em;
}

.since-box h3{
  font-size:clamp(0.9rem, 2.4vw, 1.15rem);
  line-height:1.3;
}

/* Image fills remaining height */
.stack-img{
  flex:1 1 auto;
  min-height:0;            /* REQUIRED for mobile flexbox */
  width:100%;
  object-fit:cover;
  border-radius:1rem;
}

/* ===== Text scaling ===== */
.about-title{
  font-size:clamp(1.4rem, 3.5vw, 2.5rem);
}

.about-text{
  font-size:clamp(0.85rem, 2.4vw, 1.1rem);
  line-height:1.7;
  color:"#000000 !important";
}

/* ===== Mobile fixes ===== */
@media (max-width:992px){
  .tractor-wrap img{
    min-height:180px;
    max-height:320px;
  }

  .stack-img{
    min-height:160px;
    max-height:260px;
  }

  .since-box{
    width:100%;
    padding:0.8rem;
  }
}

       `}
      </style>

      <div className="about-container">
        <div className="about-inner">
          <div className="about-card">
            <div
              id="main-about"
              className="d-flex flex-lg-row flex-column gap-4 gap-lg-5"
            >
              {/* ============ LEFT ============ */}
              <div className="about-left">
                <div className="tractor-wrap">
                  <img
                    src={`${base_Url}${
                    allImagesLink?.aboutUs?.find(
                      (item: any) => item?.fileName?.includes("img-1.png")
                    )?.fileUrl
                  }`} 
                    alt="APMC tractor"
                  />
                </div>

                <div className="stack-wrap">
                  <div className="since-box">
                    <span
                      className="fw-semibold"
                      style={{ fontSize: "0.9rem", letterSpacing: "0.05em" }}
                    >
                      {hlanguage?.about_since_year}
                    </span>
                    <h3 className="h5 fw-bold mt-2 mb-0 text-white">
                      {hlanguage?.about_market_commitee}
                    </h3>
                  </div>

                  <img
                     src={`${base_Url}${
                    allImagesLink?.aboutUs?.find(
                      (item: any) => item?.fileName?.includes("img-2.jpg")
                    )?.fileUrl
                  }`} 
                    alt="APMC market"
                    className="stack-img"
                  />
                </div>
              </div>

              {/* ============ RIGHT ============ */}
              <div className="flex-grow-1 d-flex flex-column justify-content-center">
                <h1 className="fw-bold mb-4 about-title" style={{color:"#1A5319"}}>
                  {hlanguage?.AboutUs}
                </h1>

                <div className="text-secondary about-text">
                  <p className="text-black fs-16">{hlanguage?.about_us_content_1}</p>
                  <p className="text-black fs-16">{hlanguage?.about_us_content_2}</p>
                  <p className="text-black fs-16">{hlanguage?.about_us_content_3}</p>
                  <button
                    className="btn mt-3 px-4 py-2 text-white rounded-pill fw-semibold" style={{
                      backgroundColor:"#15803d"
                    }}
                    onClick={() => navigate("/about-details", {state: {allImagesLink: allImagesLink}})}
                    >
                    {hlanguage?.readMore}
                  </button>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutNew;
